// removed by extract-text-webpack-plugin
module.exports = {"content--hidden":"style__content--hidden___2BUHa"};


//////////////////
// WEBPACK FOOTER
// ./components/AccordionContent/style.scss
// module id = 1221
// module chunks = 0